import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import UsersTable from '../../organisms/UsersTable';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flex: 1
  }
}));

const Users = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <UsersTable />
    </div>
  );
}

export default Users;